import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { chapters } from '../data/chapters';

const Header = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [desktopDropdownOpen, setDesktopDropdownOpen] = useState(null);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navLinks = [
    { label: 'Home', href: '/' },
    {
      label: 'Chapters',
      dropdown: [
        ...chapters.map(chapter => ({
          label: chapter.name,
          href: `/chapters/${chapter.slug}`,
          logo: chapter.logo,
        })),
        { label: '+ New Chapter', href: '/contact', special: true }
      ],
    },
    { label: 'Projects', href: '/projects' },
    { label: 'Workshops', href: '/workshops' },
    { label: 'Leadership', href: '/leadership' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <>
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '5rem',
        backgroundColor: 'rgba(16, 15, 28, 1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 9999,
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        padding: '0 1.1rem',
        boxSizing: 'border-box',
      }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img src="/FullLogo_Transparent_NoBuffer.png" alt="Do Quantum Logo" style={{ height: '2.5rem', cursor: 'pointer' }} />
        </a>

        {isMobile ? (
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: '2rem',
              color: 'white',
              zIndex: 101,
            }}
          >
            {menuOpen ? '\u00d7' : '☰'}
          </button>
        ) : (
          <nav style={{ display: 'flex', gap: '2rem', position: 'relative' }}>
            {navLinks.map(link => (
              <div key={link.href || link.label} style={{ position: 'relative' }}>
                {!link.dropdown ? (
                  <a
                    href={link.href}
                    style={{
                      color: location.pathname === link.href ? '#f09eff' : '#fff',
                      textDecoration: 'none',
                    }}
                  >
                    {link.label}
                  </a>
                ) : (
                  <div style={{ position: 'relative' }}>
                    <div
                      onClick={() =>
                        setDesktopDropdownOpen(
                          desktopDropdownOpen === link.label ? null : link.label
                        )
                      }
                      style={{
                        cursor: 'pointer',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.4rem',
                        fontWeight: 600,
                      }}
                    >
                      {link.label}
                      <span style={{ marginTop: '3px', fontSize: '0.75rem', color: '#ccc' }}>
                        {desktopDropdownOpen === link.label ? '▲' : '▼'}
                      </span>
                    </div>

                    {desktopDropdownOpen === link.label && (
                      <div style={{
                        position: 'absolute',
                        top: '3rem',
                        right: 0,
                        backgroundColor: '#1a1a2b',
                        border: '1px solid #444',
                        borderRadius: '0.5rem',
                        padding: '0.5rem 0',
                        minWidth: '220px',
                        maxWidth: '240px',
                        zIndex: 100,
                        boxShadow: '0 4px 10px rgba(0,0,0,0.4)',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                      }}>
                        {link.dropdown.map((sublink) => (
                          <a
                            key={sublink.href}
                            href={sublink.href}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.75rem',
                              padding: '0.75rem 1.25rem',
                              textDecoration: 'none',
                              color: sublink.special ? '#f90eff' : '#fff',
                              fontWeight: 500,
                              transition: 'background 0.2s',
                              fontStyle: sublink.special ? 'italic' : 'normal'
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = '#2a2a3d'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                          >
                            {sublink.logo && (
                              <img src={sublink.logo} alt={`${sublink.label} logo`} style={{ width: '20px', height: '20px' }} />
                            )}
                            {sublink.label}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </nav>
        )}
      </header>

      {isMobile && menuOpen && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: '#100F1C',
          zIndex: 9998,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          overflowY: 'auto',
          textAlign: 'center',
          paddingTop: '6rem',
        }}
      >
          {navLinks.map((link, idx) => (
            <React.Fragment key={link.href || link.label}>
              {!link.dropdown ? (
                <a
                  href={link.href}
                  style={{
                    padding: '0.75rem 1rem',
                    fontSize: '1.1rem',
                    color: location.pathname === link.href ? '#f09eff' : '#fff',
                    textDecoration: 'none',
                  }}
                  onClick={() => setMenuOpen(false)}
                >
                  {link.label}
                </a>
              ) : (
                <div style={{ width: '100%' }}>
                  <div
                    onClick={() =>
                      setMobileDropdownOpen(
                        mobileDropdownOpen === link.label ? null : link.label
                      )
                    }
                    style={{
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      color: '#fff',
                      cursor: 'pointer',
                      padding: '1rem 0',
                    }}
                  >
                    {link.label}{' '}
                    <span style={{ fontSize: '0.85rem', color: '#ccc' }}>
                      {mobileDropdownOpen === link.label ? '▲' : '▼'}
                    </span>
                  </div>

                  {mobileDropdownOpen === link.label &&
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.5rem',
                      padding: '0 0 0.5rem',
                    }}>
                      {link.dropdown.map((sublink) => (
                        <a
                          key={sublink.href}
                          href={sublink.href}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.75rem',
                            fontSize: '.9rem',
                            color: sublink.special ? '#f90eff' : '#ccc',
                            fontStyle: sublink.special ? 'italic' : 'normal',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            justifyContent: 'center',
                          }}
                          onClick={() => setMenuOpen(false)}
                        >
                          {sublink.logo && (
                            <img
                              src={sublink.logo}
                              alt={`${sublink.label} logo`}
                              style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                            />
                          )}
                          {sublink.label}
                        </a>
                      ))}
                    </div>
                  }
                </div>
              )}

              {idx < navLinks.length - 1 && (
                <hr
                  style={{
                    width: '60%',
                    borderColor: '#444',
                    margin: '.5rem auto',
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      )}

    </>
  );
};

export default Header;